<main class="App">
    <div *ngIf="timeError; else elseBlock" class="IERestrict">
        <div class="IERestrict-image"></div>
        <div class="IERestrict-title">Décalage important avec l'heure serveur</div>
        <div class="IERestrict-text">
            Un décalage temporel trop important a été détecté entre votre machine et le serveur d'authentification.<br />
            Merci de régler l'heure de votre machine  à {{timeIat}}.
        </div>
        <br />
        <div class="IERestrict-text">
            {{ 'Unauthorized.Code_Erreur' | translate }} : {{codeErreur}}
        </div>
        <br />
        <div class="IERestrict-text">Pour vous déconnecter, cliquez <a (click)="logout()">ici</a></div>
    </div>
    <ng-template #elseBlock>
        <div class="IERestrict">
            <div class="IERestrict-image"></div>
            <div class="IERestrict-title">Action non autorisée</div>
            <div class="IERestrict-text">
                Une action non autorisée a été détectée.<br />
                Merci de contacter le service client GS1 France au <strong>01 40 22 18 00</strong> ou par email <strong><a href='mailto:serviceclient@gs1fr.org'>serviceclient@gs1fr.org</a></strong>.
            </div>
            <br />
            <div class="IERestrict-text">
                {{ 'Unauthorized.Code_Erreur' | translate }} : {{codeErreur}}
            </div>
            <br />
            <div class="IERestrict-text">Pour vous déconnecter, cliquez <a (click)="logout()">ici</a></div>
        </div>
    </ng-template>

</main>
